export default [
    {
        path: 'fechamento-faa',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-fechamento-faa' */
            '@/views/pronto-atendimento/fechamento-faa/Index'
        ),
        redirect: 'fechamento-faa/index',
        children: [
            {
                name: 'pronto-atendimento-fechamento-faa-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-fechamento-faa' */
                    '@/views/pronto-atendimento/fechamento-faa/List'
                ),
            },
        ],
    },
]